// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Represents a context that is shared with all ILog instances.
 * Used to configure global logging properties.
 */
export type LogContext = {
  rootName: string;
  defaultLogLevel: LogLevel;
};